<template>
    <div class="shop-alternate-address">
        <global-address-administration :addresses="addresses"
                                       :show="show"
                                       @saveChanges="saveToStorage($event.detail)"
                                       @close="closeAlternateAddress"
        />
    </div>
</template>

<script>
import GlobalAddressAdministration
    from "@global/global-elements/global-address-administration/global-address-administration";
export default {
    name: "shop-alternate-address",
    components: {GlobalAddressAdministration},
    props: {
        userAddress: {},
        show: false,
    },
    data() {
        return {
            addresses: [],
            storageKey: "cartAddresses_" + window.market
        }
    },
    computed: {
        localization() {
            return window.cartLocalization
        },
    },
    methods: {
        saveLastUsed(addressId) {
            if (localStorage) {
                const addresses = JSON.parse(localStorage.getItem(this.storageKey));
                addresses.forEach(address => {
                    if (address.id === addressId) {
                        address.lastUsed = true;
                    } else {
                        address.lastUsed = false;
                    }
                })

                localStorage.setItem(this.storageKey, JSON.stringify(addresses))
            }
        },
        saveToStorage(addresses) {
            if (localStorage) {
                localStorage.setItem(this.storageKey, JSON.stringify(addresses))
            }
        },
        closeAlternateAddress(event) {
            if (event && event.detail) {
                this.$emit('alternateAddress', { detail: event.detail})
            }

            this.$emit('close')
        }
    },
    mounted() {
        if (localStorage) {
            const storageObject = localStorage.getItem(this.storageKey)
            if (storageObject) {
                this.addresses = JSON.parse(storageObject)
            }
        }

        this.addresses.push(Object.assign({mainAddress: true}, this.userAddress))
    }
}
</script>
